
/*
  File: {file_name}
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/


/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

// Header.js

import React from "react";
import styles from "./Header.module.css";

interface HeaderProps {
  header: string;
  subheader: string;
  icon?: string;
}

const Header: React.FC<HeaderProps> = ({ header, subheader, icon }) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerContent}>
        {icon && (
          <img src={icon} alt="Header Icon" className={styles.headerIcon} />
        )}
        <div className={styles.headerTextContainer}>
          <span className={styles.headerText}>{header}</span>
          <span className={styles.subheaderText}>{subheader}</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
